import { BrowserModule } from '@angular/platform-browser';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { AppRoutingModule } from './app-routing.module';
import { HttpClientModule } from '@angular/common/http';
import { AppComponent } from './app.component';
import { AngularFireModule } from '@angular/fire';
import { AngularFirestoreModule } from '@angular/fire/firestore';
import { environment } from '../environments/environment';

import { PlayersComponent } from '../app/players/players.component';
import { HomeComponent } from '../app/home/home.component';
import { StatsComponent } from '../app/players/stats/stats.component';
import { HistoryComponent } from '../app/players/history/history.component';
import { SummaryComponent } from '../app/players/summary/summary.component';
import { LeaderboardComponent } from '../app/home/leaderboard/leaderboard.component';
import { NoopAnimationsModule } from '@angular/platform-browser/animations';
import { MatSortModule, MatTableModule } from '@angular/material';
import { BaseTableComponent } from './base/base-table/base-table.component';

@NgModule({
  declarations: [
    AppComponent,
    PlayersComponent,
    HomeComponent,
    StatsComponent,
    HistoryComponent,
    SummaryComponent,
    LeaderboardComponent,
    BaseTableComponent
  ],
  imports: [
    BrowserModule,
    NgbModule,
    FormsModule,
    AngularFireModule.initializeApp(environment.firebase),
    AngularFirestoreModule,
    AppRoutingModule,
    HttpClientModule,
    NoopAnimationsModule
  ],
  exports: [
    MatSortModule, 
    MatTableModule
  ],
  providers: [],
  bootstrap: [AppComponent, PlayersComponent, HomeComponent, StatsComponent, HistoryComponent, SummaryComponent, LeaderboardComponent]
})
export class AppModule { }
